var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetBkgd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1635 1635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.1;}.cls-2{fill:#1f2b5c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.5,1634.5a817.21,817.21,0,0,1-318-1569.8,817.21,817.21,0,0,1,636,1505.6A811.91,811.91,0,0,1,817.5,1634.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5,1A822.28,822.28,0,0,1,982.05,17.59a811.8,811.8,0,0,1,292,122.85,818.92,818.92,0,0,1,295.83,359.24A812.69,812.69,0,0,1,1617.41,653a824.35,824.35,0,0,1,0,329.1,811.8,811.8,0,0,1-122.85,292,818.92,818.92,0,0,1-359.24,295.83,812.69,812.69,0,0,1-153.27,47.57,824.35,824.35,0,0,1-329.1,0,811.8,811.8,0,0,1-292-122.85A818.92,818.92,0,0,1,65.16,1135.32,812.69,812.69,0,0,1,17.59,982.05a824.35,824.35,0,0,1,0-329.1A811.8,811.8,0,0,1,140.44,361,818.92,818.92,0,0,1,499.68,65.16,812.69,812.69,0,0,1,653,17.59,822.28,822.28,0,0,1,817.5,1m0-1C366,0,0,366,0,817.5S366,1635,817.5,1635,1635,1269,1635,817.5,1269,0,817.5,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.5,1444.5a625,625,0,1,1,244.06-49.27A623.19,623.19,0,0,1,817.5,1444.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5,191a623.44,623.44,0,0,1,350.28,107,628.44,628.44,0,0,1,227,275.64A625.61,625.61,0,0,1,1337,1167.78a628.44,628.44,0,0,1-275.64,227A625.61,625.61,0,0,1,467.22,1337a628.44,628.44,0,0,1-227-275.64A625.61,625.61,0,0,1,298,467.22a628.44,628.44,0,0,1,275.64-227A622.54,622.54,0,0,1,817.5,191m0-1C470.94,190,190,470.94,190,817.5S470.94,1445,817.5,1445,1445,1164.06,1445,817.5,1164.06,190,817.5,190Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.5,1267a448,448,0,1,1,175-35.32A446.71,446.71,0,0,1,817.5,1267Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5,368.5a447.54,447.54,0,1,1-174.77,35.28A446.2,446.2,0,0,1,817.5,368.5m0-1c-248.53,0-450,201.47-450,450s201.47,450,450,450,450-201.47,450-450-201.47-450-450-450Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.5,1087a269.48,269.48,0,1,1,190.57-78.93A267.76,267.76,0,0,1,817.5,1087Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5,548.5a268.13,268.13,0,1,1-104.71,21.14A267.28,267.28,0,0,1,817.5,548.5m0-1c-149.12,0-270,120.88-270,270s120.88,270,270,270,270-120.88,270-270-120.88-270-270-270Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 817.5,
    cy: 817.5,
    r: 89.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5,728.5a89,89,0,1,1-89,89,89.11,89.11,0,0,1,89-89m0-1a90,90,0,1,0,90,90,90,90,0,0,0-90-90Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetBkgd);
export default __webpack_public_path__ + "static/media/target-bkgd.7f88848f3dd07b1d912a89dc6dc8cc4c.svg";
export { ForwardRef as ReactComponent };